import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email"]

  connect() {
    // Focus email input when modal opens
    this.element.closest("[data-controller='modal']").addEventListener("modal:opened", () => {
      setTimeout(() => {
        this.emailTarget.focus()
      }, 100)
    })
  }

  reset() {
    this.element.reset()
  }
} 
